export default "/50f517735fec46580f19aae3e56e9fe21614ea75/83e791c702f67cc0242109b04d241be7.svg";